import { render, staticRenderFns } from "./ProductLifecycle.vue?vue&type=template&id=747705ca&scoped=true&"
import script from "./ProductLifecycle.vue?vue&type=script&lang=js&"
export * from "./ProductLifecycle.vue?vue&type=script&lang=js&"
import style0 from "./ProductLifecycle.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ProductLifecycle.vue?vue&type=style&index=1&id=747705ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747705ca",
  null
  
)

export default component.exports